<template>
  <header class="border-b border-white border-opacity-20 md:border-transparent py-3 mb-8">
    <div class="w-full max-w-screen-lg mx-auto px-3">
      <div class="flex justify-between items-center">
        <div>
          <img
            src="https://cdn.rcstatic.com/images/site_graphics/newsite/mobile/logos/rc-logo-small--white.svg"
            alt=""
          />
        </div>
        <div>
          <div class="md:hidden my-4">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="far"
              data-icon="bars"
              class="w-4 h-4 text-white"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path
                fill="currentColor"
                d="M424 392H23.1C10.8 392 0 402.8 0 415.1C0 429.2 10.8 440 23.1 440H424c13.2 0 24-10.8 24-23.1C448 402.8 437.2 392 424 392zM424 72H23.1C10.8 72 0 82.8 0 95.1S10.8 120 23.1 120H424c13.2 0 24-10.8 24-23.1S437.2 72 424 72zM424 232H23.1C10.8 232 0 242.8 0 256c0 13.2 10.8 24 23.1 24H424C437.2 280 448 269.2 448 256S437.2 232 424 232z"
              ></path>
            </svg>
          </div>
          <div class="hidden md:flex items-center">
            <div class="text-white text-sm">EUR</div>
            <div class="mx-5">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 512 512">
                <mask id="a"><circle cx="256" cy="256" r="256" fill="#fff" /></mask>
                <g mask="url(#a)">
                  <path
                    fill="#eee"
                    d="M0 0h47.4l76.4 21 65.4-21h33.4l34.2 16.6L289.4 0h33.4l70.4 22.8L464.8 0h15.8l12.2 7.3L512 0v47.3l-19.9 78 19.9 63.9v33.4l-16.4 30.6 16.4 36.2v33.4l-15.1 68.7 15.1 73.3v15.9l-7.8 10.9L512 512h-47.3l-71-17.5-70.9 17.5h-33.4l-30-19.7-36.8 19.7h-33.3l-63.7-20.2L47.3 512H31.4l-10.6-8L0 512v-47.3l22.8-79L0 322.9v-33.4l25.3-32L0 222.6v-33.4l22.2-64.6L0 47.2V31.4l8-7.8z"
                  />
                  <path
                    fill="#0052b4"
                    d="M47.4 0l141.8 142V0H47.4zm275.4 0v142l142-142h-142zM0 47.2v142h142L0 47.2zm512 .1L370.1 189.2H512V47.3zM0 322.8v141.9l141.9-141.9H0zm370 0l142 142v-142H370zM189.3 370l-142 142h142V370zm133.5.1V512h141.9L322.8 370.1z"
                  />
                  <path fill="#d80027" d="M222.6 0v222.6H0v66.8h222.6V512h66.8V289.4H512v-66.8H289.4V0h-66.8z" />
                  <path
                    fill="#d80027"
                    d="M0 0v31.4l157.7 157.8h31.5L0 0zm480.6 0L322.8 157.7v31.5L512 0h-31.4zM189.2 322.8L0 512h31.4l157.8-157.7v-31.5zm133.6 0L511.9 512h.1v-31.3L354.3 322.8h-31.5z"
                  />
                </g>
              </svg>
            </div>
            <div><button class="bg-white text-rental-blue-500 p-3 rounded text-sm">Manage booking</button></div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'app-header',
}
</script>
